// purposes
import D2C_ProviderHosting from './Hosting'
import D2C_ProviderLog from './Log'
import D2C_ProviderStorage from './Storage'
// hosting providers
import D2C_ProviderAWS from './AWS'
import D2C_ProviderCustom from './Custom'
import D2C_ProviderDO from './DO'
import D2C_ProviderGCP from './GCP'
import D2C_ProviderUpcloud from './Upcloud'
import D2C_ProviderVultr from './Vultr'
// storage providers
import D2C_ProviderBackblaze from './Backblaze'
import D2C_ProviderDropbox from './Dropbox'
import D2C_ProviderFTP from './FTP'
import D2C_ProviderHubic from './Hubic'
import D2C_ProviderOneDrive from './OneDrive'
import D2C_ProviderS3 from './S3'
import D2C_ProviderSFTP from './SFTP'
import D2C_ProviderSpaces from './Spaces'
// logs provider
import D2C_ProviderGelf from './Gelf'

export default {
  // purposes
  ProviderHosting: D2C_ProviderHosting,
  ProviderLog: D2C_ProviderLog,
  ProviderStorage: D2C_ProviderStorage,
  // hosting providers
  ProviderAWS: D2C_ProviderAWS,
  ProviderDO: D2C_ProviderDO,
  ProviderCustom: D2C_ProviderCustom,
  ProviderGCP: D2C_ProviderGCP,
  ProviderUpcloud: D2C_ProviderUpcloud,
  ProviderVultr: D2C_ProviderVultr,
  // storage providers
  ProviderBackblaze: D2C_ProviderBackblaze,
  ProviderDropbox: D2C_ProviderDropbox,
  ProviderFTP: D2C_ProviderFTP,
  ProviderHubic: D2C_ProviderHubic,
  ProviderOneDrive: D2C_ProviderOneDrive,
  ProviderS3: D2C_ProviderS3,
  ProviderSFTP: D2C_ProviderSFTP,
  ProviderSpaces: D2C_ProviderSpaces,
  // log provider
  ProviderGelf: D2C_ProviderGelf,
}
